export default {
  BusinessStockSynchronization: {
    header: {
      warehouseCode: '逻辑仓编码',
      warehouseName: '逻辑仓名称',
      synchronisedTime: '同步时间'
    },
    table: {
      adjustCode: '数据同步单号',
      warehouseCode: '逻辑仓编码',
      warehouseName: '逻辑仓名称',
      lastUpdateName: '操作人员',
      lastUpdateDate: '操作时间',
    },
   review: '审核',
  }
};
